import { render, staticRenderFns } from "./AiPromptTemplatesTable.vue?vue&type=template&id=86711be6"
import script from "./AiPromptTemplatesTable.vue?vue&type=script&lang=js"
export * from "./AiPromptTemplatesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports